import React from 'react';
import { Box, Typography, Switch, FormControlLabel, Stack } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { OrganizationTrainingConfig } from '../../../_types/training';

interface EditProps {
  config: OrganizationTrainingConfig;
  onChange: (config: OrganizationTrainingConfig) => void;
}

const Edit: React.FC<EditProps> = ({ config, onChange }) => {
  const handleModuleToggle = (moduleId: string, checked: boolean) => {
    const updatedModules = config.modules.map((module) =>
      module.id === moduleId
        ? {
            ...module,
            status: (checked ? 'ENABLED' : 'DISABLED') as 'ENABLED' | 'DISABLED',
          }
        : module
    );
    onChange({
      ...config,
      modules: updatedModules,
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography
        variant='subtitleSm'
        sx={{ mb: 3 }}
      >
        {t('manageSolutions.training.activeSubscriptions')}
      </Typography>
      <Stack spacing={3}>
        {config.modules.map((module) => {
          const isEnabled = module.status === 'ENABLED';
          return (
            <Box
              key={module.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 3,
              }}
            >
              <FormControlLabel
                control={
                  <Switch
                    checked={isEnabled}
                    onChange={(_, checked) => handleModuleToggle(module.id, checked)}
                    color='success'
                    size='xs'
                  />
                }
                label={module.name}
                sx={{ flex: 1, m: 0 }}
              />
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};

export default Edit;
